import {
  ASSINATURA_CREATE,
  ASSINATURA_LOAD,
  ASSINATURA_REMOVE,
  ASSINATURA_TYPE_REMOVE
} from "../actions/assinatura";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [ASSINATURA_CREATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.subscription.type
        .save(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ASSINATURA_REMOVE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.subscription
        .cancel(payload)
        .then(resolve)
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ASSINATURA_TYPE_REMOVE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.subscription.type
        .remove(payload)
        .then(resolve)
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ASSINATURA_LOAD]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.subscription
        .get(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
